var _path, _circle, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestroomAccessories(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9 3.3C2.9 2.30589 3.70589 1.5 4.7 1.5H19.7C20.6941 1.5 21.5 2.30589 21.5 3.3V21.3C21.5 22.2941 20.6941 23.1 19.7 23.1H4.7C3.70589 23.1 2.9 22.2941 2.9 21.3V3.3Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2,
    cy: 5.7,
    r: 1.5,
    className: "Icon-fill-color",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.495 12.2817C15.8031 13.4374 15.9571 14.0153 15.6569 14.4061C15.3567 14.7968 14.7586 14.7968 13.5623 14.7968L10.7688 14.7968C9.57253 14.7968 8.9744 14.7968 8.67419 14.4061C8.37397 14.0153 8.52808 13.4374 8.83631 12.2817L9.10298 11.2817C9.29332 10.5679 9.38849 10.211 9.65793 10.004C9.92738 9.79688 10.2967 9.79688 11.0354 9.79688H13.2957C14.0344 9.79688 14.4038 9.79688 14.6732 10.004C14.9426 10.211 15.0378 10.5679 15.2281 11.2817L15.495 12.2817Z",
    className: "Icon-fill-color",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9548 14.7931C14.0204 13.7107 13.1602 12.7969 12.0757 12.7969C10.9913 12.7969 10.1311 13.7107 10.1967 14.7931L10.6617 22.4659C10.707 23.2136 11.3266 23.7969 12.0757 23.7969C12.8248 23.7969 13.4444 23.2136 13.4897 22.4659L13.9548 14.7931Z",
    className: "Icon-fill-color",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestroomAccessories);
export default __webpack_public_path__ + "static/media/RestroomAccessories.828c8de92495ce861341512e510d86a1.svg";
export { ForwardRef as ReactComponent };